
import PricingHeader from '@/components/pricing/header.vue'
import PricingPlans from '@/components/pricing/plans.vue'
export default {
  name: 'Pricing',
  components: { PricingPlans, PricingHeader }
}
